<template>
    <USlideover v-model="isShowingLogin" side="right" :overlay="true">
        <FormAuthLogin />
        <FormAuthResetPassword />
    </USlideover>
</template>

<script setup>
    const { isShowingLogin } = inject('login')
</script>
